import MypagePage from '@/pages/mypage/inquiryView.vue';
import MypagePaymentPage from '@/pages/mypage/subscrPaymentView.vue';

export const mypageRoutes = [
  {
    path: '/mypage/inquiryView/:boardName/:id',
    component: MypagePage,
    meta: {
      layout: 'mypage',
    },
  },
  {
    path: '/mypage/subscrPaymentView/:id',
    component: MypagePaymentPage,
    meta: {
      layout: 'mypage',
    },
  },
];
